import { useApiGet } from '../../api/Api.hooks';

export interface StudyParticipantFile {
  url: string;
  name: string;
  size: number;
  created: Date;
}

export function useGetStudyParticipantFiles(studyParticipantId: number) {
  const { data, isLoading, error, get } = useApiGet<StudyParticipantFile[]>(
    `study-participants/${studyParticipantId}/files`
  );
  return {
    studyParticipantFiles: data,
    loadingStudyParticipantFiles: isLoading,
    loadingStudyParticipantFilesError: error,
    getStudyParticipantFiles: get
  };
}
